




















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import DialogPage from '@/core/components/uploader/DialogPage.vue';
import Files from '@/core/components/uploader/Files.vue';
import Status from '@/core/components/uploader/Status.vue';
import { localize } from '@/core/filters';
import { uploadFile } from '@/core/helpers';
import { CONTRACTS, FetchServiceContract } from '@/core/contracts';

/**
 * There are 3 stages of uploading file:
 *  1. select file
 *  2. upload file to server
 *  3. error
 */

@Component({
    components: {
        DialogPage,
        Files,
        Status
    }
})
export default class FileUploader extends Vue {
    public stage: number = 1;
    private progress: number | null = null;

    @Inject(CONTRACTS.FetchService) private _fetchService?: FetchServiceContract;

    public get progressString(): string | undefined {
        return this.progress !== null
            ? `${localize('FileUploader_Stage_UploadingText')}: ${this.progress}%`
            : undefined;
    }

    public uploadFile(files: File[]) {
        if (files.length > 0) {
            this.stage = 2;
            const url = this._fetchService!.buildAbsoluteUrl('/api/v2/files/storage');
            uploadFile<void>(files[0], url, this.onProgress)
            .then(data => this.close())
            .catch((error) => this.error());
        }
    }

    public error() {
        this.stage = 3;
    }

    private close() {
        this.$emit('close');
    }

    private onProgress(event: ProgressEvent<XMLHttpRequestEventTarget>) {
        if (event.lengthComputable) {
            this.progress = Math.ceil(event.loaded / event.total * 100);
        }
    }
}
